import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { customersApi, type CustomerListParams } from '../api/customers-api';

import { customerKeys } from './customer-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function customerListQueryOptions(storeId: string, params: CustomerListParams) {
  return queryOptions({
    queryKey: customerKeys.list(storeId, params),
    queryFn: () => customersApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useCustomers(storeId: string, params: CustomerListParams) {
  return useQuery(customerListQueryOptions(storeId, params));
}
